<div
  class="sidenav sidenav-{{ isCollapsed ? 'collapsed' : 'expanded' }}"
  *ngIf="isUsrLoggedIn() && get_user_type() === 'MM'"
>
  <div class="sidenav-header-container">
    <div
      class="sidenav-header-icon"
      [routerLink]="isHqUser ? 'hq/restaurant/restaurant-details' : '/restaurant/restaurant-details'"
      [routerLinkActive]="'link-disabled'"
    >
    <img [src]="isHqUser ? hqLogo : restaurantDetails?.logo" (error)="utilService.handleImageError($event, images.RESTAURANT)" class="rest-img"
      alt="logo" />
    </div>
    <div class="sidenav-header-title">
      <div class="restaurant-title-text">
        {{ get_restaurant_name() | titlecase }}
      </div>
      <div
        *ngIf="hasRestDetailsViewPermission()"
        class="edit-resturant"
        style="cursor: pointer"
        [routerLink]="isHqUser ? 'hq/restaurant/restaurant-details' : '/restaurant/restaurant-details'"
        [routerLinkActive]="'link-disabled'"
      >
        {{ 'SIDENAV.EDIT_RESTAURANT_DETAILS' | fallbackTranslate }}
      </div>
      <div
        class="sidebar-toggler"
        (click)="onCollapseToggleClick()"
        nzTheme="outline"
        nzTooltipTitle="{{
          hideTooltip
            ? null
            : isCollapsed
            ? 'Open Navigation'
            : 'Close Navigation'
        }}"
        nzTooltipPlacement="right"
        nz-tooltip
      >
        <i
          class="fa fa-chevron-left fa-rotate-{{ isCollapsed ? '180' : '0' }}"
        ></i>
      </div>
    </div>
  </div>
  <hr class="hr-sidenav m-b-0" />

  <div class="sidenav-routes-container p-t-10 p-b-10">
    <div class="sidenav-routes-section">
      <div class="sidenav-routes-section-header">
        {{ 'SIDENAV.MAIN' | fallbackTranslate }}
      </div>

      <div
        class="sidenav-routes-section-link"
        routerLink="/hq/dashboard"
        [ngClass]="{ 'link-active': eehqActive.isActive }"
        (click)="tabclicked('ee-hq')"
        *ngIf="isHqUser && validUrl['ee_hq']"
      >
      <div class="flex flex-3 gap-3">
        <div>
          <img [src]="images.EE_HQ" class="routes-img" alt="hq-img" />
        </div>
        <div class="sidenav-title">
          <a rel="nofollow">
            <span class="wb-break-word ws-normal">
              {{ 'SIDENAV.EE_HQ' | fallbackTranslate }}
            </span>
          </a>
        </div>
      </div>
      </div>

      <div
        class="sidenav-routes-section-link"
        [routerLink]="'hq/pending-orders'"
        [ngClass]="{ 'link-active': pendingOrdersActive.isActive }"
        *ngIf="isHqUser && hqFcShowOrderDashBoard"
      >
        <div>
          <img [src]="images.NAV_ORDER" class="routes-img" alt="order-img"/>
        </div>
        <div class="sidenav-title">
          <a rel="nofollow">
            <span class="wb-break-word ws-normal">{{ 'SIDENAV.ORDERS' | fallbackTranslate }}&nbsp;</span>
            <nz-badge
              nzStandalone
              [nzCount]="allFoodCourtOrderCount"
              [nzOverflowCount]="99"
            ></nz-badge>
          </a>
        </div>
      </div>

      <div
        class="sidenav-routes-section-link"
        routerLink="/hq/outlets"
        [ngClass]="{ 'link-active': outletsActive.isActive }"
        (click)="tabclicked('outlets')"
        *ngIf="isHqUser && validUrl['hq_outlets']"
      >
      <div class="flex flex-3 gap-3">
        <div>
          <img [src]="images.STORE" class="routes-img" alt="store-img"/>
        </div>
        <div class="sidenav-title">
          <a rel="nofollow">
            <span class="wb-break-word ws-normal">
              {{ 'SIDENAV.OUTLETS' | fallbackTranslate }}
            </span>
          </a>
        </div>
        </div>
      </div>

      <div
      class="sidenav-routes-section-link"
      routerLink="/hq/billing"
      [ngClass]="{ 'link-active': billingActive.isActive }"
      (click)="tabclicked('billing')"
      *ngIf="isHqUser && validUrl['billing'] && isMyEnvironment"
    >
    <div class="flex flex-3 gap-3">
    <div>
      <img [src]="images.INVOICE" class="routes-img"  alt="invoice-img"/>
    </div>
      <div class="sidenav-title"> 
        <a rel="nofollow">
          <span class="wb-break-word ws-normal">
            {{ 'SIDENAV.BILLING' | fallbackTranslate}}
          </span>
        </a>
      </div>
    </div>
    </div>

      <div
        class="sidenav-routes-section-link flex flex_sb gap-2"
        [routerLink]="!handleBlocked('orders') ? '/orders' : null"
        [ngClass]="{ 'link-active': ordersActive.isActive }"
        (click)="tabclicked('orders')"
        *ngIf="!isHqUser"
      >
      <div class="flex flex-3 gap-3">
        <div [ngClass]="{'nav-locked-blur': handleBlocked('orders')}">
          <img [src]="images.NAV_ORDER" class="routes-img"  alt="order-img"/>
        </div>
        <div class="sidenav-title" [ngClass]="{'nav-locked-blur': handleBlocked('orders')}">
          <a rel="nofollow" class="flex gap-2">
            <span class="wb-break-word ws-normal">{{ 'SIDENAV.ORDERS_DASHBOARD' | fallbackTranslate }}</span>
            <!-- <div class="notification" *ngIf="validOrders.length !== 0">
              {{ validOrders.length }}
            </div> -->
            <nz-badge
              nzStandalone
              [nzCount]="validOrders.length"
              [nzOverflowCount]="99"
              *ngIf="validOrders.length != 0 && !handleBlocked('orders')"
            ></nz-badge>
          </a>
        </div>
        </div>
        <div class="flex flex-center fs-10 locked-bg gap-1"  *ngIf="handleBlocked('orders')" >
          <img
          [src]="images.RED_LOCK_ICON"
          alt="lock"
        />
          {{ 'SIDENAV.LOCKED' | fallbackTranslate }}</div>
      </div>

      <div
        class="sidenav-routes-section-link flex flex_sb gap-2"
        [routerLink]="!handleBlocked('reports') ? (isHqUser ? 'hq/reports' : '/reports') : null"
        [ngClass]="{ 'link-active': reportsActive.isActive }"
        (click)="tabclicked('reports')"
        *ngIf="(!isKiosk && validUrl['report']) || (isKiosk && kioskCashReport)"
      >
      <div class="flex flex-3 gap-3">
        <div [ngClass]="{'nav-locked-blur': handleBlocked('reports')}">
          <img [src]="images.INVOICE" class="routes-img"  alt="invoice-img"/>
        </div>
        <div class="sidenav-title" [ngClass]="{'nav-locked-blur': handleBlocked('reports')}">
          <a rel="nofollow">
            <span class="wb-break-word ws-normal">
              {{ 'SIDENAV.REPORTS' | fallbackTranslate }}
            </span>
          </a>
        </div>
        </div>
        <div class="flex flex-center fs-10 locked-bg gap-1"  *ngIf="handleBlocked('reports')" >
          <img
          [src]="images.RED_LOCK_ICON"
          alt="lock"
        />
          {{ 'SIDENAV.LOCKED' | fallbackTranslate }}</div>
      </div>

      <div
        class="sidenav-routes-section-link flex flex_sb gap-2"
        [routerLink]="!handleBlocked('tableservice') ? '/tableservice' : null"
        [ngClass]="{ 'link-active': tableserviceActive.isActive }"
        (click)="tabclicked('tableservice')"
        *ngIf="!isHqUser && validUrl['table-service'] && !isKiosk && !pricing && !isKioskChild"
      >
      <div class="flex flex-3 gap-3">
        <div [ngClass]="{'nav-locked-blur': handleBlocked('tableservice')}">
          <img
            [src]="images.DINING_ROOM"
            class="routes-img"
            alt="dinning-img"
          />
        </div>
        <div class="sidenav-title" [ngClass]="{'nav-locked-blur': handleBlocked('tableservice')}">
          <a rel="nofollow">
            <span class="wb-break-word ws-normal">{{ 'SIDENAV.TABLE_SERVICE' | fallbackTranslate }}</span>
            <nz-badge
            nzStandalone
            [nzCount]="allNotification.length"
            [nzOverflowCount]="99"
            *ngIf="allNotification.length != 0 && !handleBlocked('tableservice')"
            ></nz-badge>
          </a>
        </div>
      </div>
        <div class="flex flex-center fs-10 locked-bg gap-1"  *ngIf="handleBlocked('tableservice')" >
          <img
          [src]="images.RED_LOCK_ICON"
          alt="lock"
        />
          {{ 'SIDENAV.LOCKED' | fallbackTranslate }}</div>
      </div>
      <div
        class="sidenav-routes-section-link flex flex_sb gap-2"
        [routerLink]="!handleBlocked('table-layout') ? '/tables' : null"
        [ngClass]="{ 'link-active': tableLayoutActive.isActive }"
        (click)="tabclicked('table-layout')"
        *ngIf="showTableLayout() && !isKiosk && !isMobile && !isKioskChild"
      >
      <div class="flex flex-3 gap-3">
        <div [ngClass]="{'nav-locked-blur': handleBlocked('table-layout')}">
          <img
            [src]="images.DINING_TABLE"
            class="routes-img"
            alt="dinning-table"
          />
        </div>
        <div [ngClass]="{'nav-locked-blur': handleBlocked('table-layout')}">
          <a rel="nofollow" class="flex_sb ">
            <span class="m-r-30 wb-break-word ws-normal">{{ 'SIDENAV.TABLES' | fallbackTranslate }}</span>
          </a>
        </div>
      </div>
        <div class="flex flex-center fs-10 locked-bg gap-1"  *ngIf="handleBlocked('table-layout')">
          <img
          [src]="images.RED_LOCK_ICON"
          alt="lock"
        />
          {{ 'SIDENAV.LOCKED' | fallbackTranslate }}</div>
      </div>

      <div
        class="sidenav-routes-section-link flex flex_sb gap-2"
        [routerLink]="!handleBlocked('table-bookings') ? '/table-bookings' : null"
        [ngClass]="{ 'link-active': tablebookingsActive.isActive }"
        (click)="tabclicked('table-bookings')"
        *ngIf="!isHqUser && validUrl['table-service'] && !isKiosk && !isKioskChild && isTableReservationEnabled"
      >
      <div class="flex flex-3 gap-3">
        <div [ngClass]="{'nav-locked-blur': handleBlocked('table-bookings')}">
          <img
            [src]="images.TABLE_BOOKING_ICON"
            class="routes-img"
            [ngClass]="{'zoom': nudgeTableBooking}"
            alt="table"
          />
        </div>
        <div class="sidenav-title flex flex_sb gap-2 p-r-5" [ngClass]="{'nav-locked-blur': handleBlocked('table-bookings')}">
          <a rel="nofollow"> 
            <span class="wb-break-word ws-normal"> {{ 'SIDENAV.TABLE_BOOKINGS' | fallbackTranslate }} </span>
            <nz-badge nzStandalone [nzCount]="tableBookingLength" [nzOverflowCount]="99" *ngIf="tableBookingLength !== 0 && !handleBlocked('table-bookings')"></nz-badge>
          </a>
        </div>
      </div>
      <div class="flex flex-center fs-10 locked-bg gap-1" *ngIf="handleBlocked('table-bookings')">
        <img
        [src]="images.RED_LOCK_ICON"
        alt="lock"
      />
        {{
        'SIDENAV.LOCKED' | fallbackTranslate }}</div>
      </div>

      <!--Hide AI Insights tab for now -->
      <!-- <div
        class="sidenav-routes-section-link flex flex_sb gap-2"
        [routerLink]="!handleBlocked('ai-insights') ? '/ai-insights' : null"
        [ngClass]="{ 'link-active': aiInsightsTabActive.isActive }"
        (click)="tabclicked('aiInsights')"
        *ngIf="validUrl['ai-insights']"
      >
        <div class="flex flex-3 gap-3">
          <div [ngClass]="{ 'nav-locked-blur': handleBlocked('table-layout') }">
            <img
              [src]="images?.AI_SIDENAV_ICON"
              class="routes-img"
              alt="ai icon"
            />
          </div>
          <div [ngClass]="{ 'nav-locked-blur': handleBlocked('ai-insights') }">
            <a rel="nofollow" class="flex_sb">
              <span class="m-r-30 wb-break-word ws-normal">{{
                'SIDENAV.AI_POWERED_INSIGHTS' | fallbackTranslate
              }}</span>
            </a>
          </div>
        </div>
        <div
          class="flex flex-center fs-10 locked-bg gap-1"
          *ngIf="handleBlocked('ai-insights')"
        >
          <img [src]="images?.RED_LOCK_ICON" alt="lock icon" />
          {{ 'SIDENAV.LOCKED' | fallbackTranslate }}
        </div>
      </div> -->
    </div>

    <div class="sidenav-routes-section">
      <div class="sidenav-routes-section-header">
        {{ 'SIDENAV.SETTINGS' | fallbackTranslate }}
      </div>

      <div
      class="sidenav-routes-section-link"
      [routerLink]="'hq/marketing'"
      [ngClass]="{ 'link-active': marketingSettingActive.isActive }"
      (click)="tabclicked('marketing')"
      *ngIf="isHqUser && atleastOneProSubs && !isKioskHq "
    >
    <div class="flex flex-3 gap-3">
      <div>
        <img [src]="images.MARKETING" class="routes-img" alt="marketing" />
      </div>
      <div class="sidenav-title flex gap-2">
        <a rel="nofollow">
          <span class="wb-break-word ws-normal">
            {{ 'SIDENAV.MARKETING' | fallbackTranslate }}
          </span>
        </a>
        <div class="zoom">
          <nz-tag
          [nzColor]="'#ef2d41'"
          >{{ 'SIDENAV.NEW' | fallbackTranslate }} </nz-tag>
        </div>
      </div>
    </div>
    </div>

      <!-- Checks if a HQ user && CMM is active , then loads Menu & Dishes tab -->
      <ng-container *ngIf="isHqUser && isHQCmmActive  && viewCentralMenu && !isMobile">
        <ng-content *ngTemplateOutlet="menuDishesNavtab"></ng-content>
      </ng-container>

      <!-- Checks if a POS user, then loads Menu tab -->
      <ng-container *ngIf="!isHqUser">
        <ng-content *ngTemplateOutlet="menuDishesNavtab"></ng-content>
      </ng-container>


      <!-- Common Template code to render for Menu Tab -->
      <ng-template #menuDishesNavtab>
        <div class="sidenav-routes-section-link flex flex_sb gap-2"
          [routerLink]="!handleBlocked('menu') ? (isHqUser ? 'hq/menu-management' : '/menu'):null" [ngClass]="{
                    'link-active': menuActive.isActive || dishesActive.isActive
                  }" (click)="tabclicked('menu')" *ngIf="validUrl['menu'] && !isKiosk">
          <div class="flex flex-3 gap-3">
            <div [ngClass]="{'nav-locked-blur': handleBlocked('menu')}">
              <img [src]="images.NAV_MENU" class="routes-img" alt="nav-menu" />
            </div>
            <div class="sidenav-title" [ngClass]="{'nav-locked-blur': handleBlocked('menu')}">
              <a rel="nofollow">
                <span class="wb-break-word ws-normal">{{
                  (isHqUser ? 'SIDENAV.MENU_DISHES' : 'SIDENAV.MENU') | fallbackTranslate
                  }}</span>
              </a>
            </div>
          </div>
          <div class="flex flex-center fs-10 locked-bg gap-1" *ngIf="handleBlocked('menu')">
            <img
            [src]="images.RED_LOCK_ICON"
            alt="lock"
          />
            {{
            'SIDENAV.LOCKED' | fallbackTranslate }}</div>
        </div>
      </ng-template>

      <div
        class="sidenav-routes-section-link flex flex_sb gap-2"
        [routerLink]="!handleBlocked('restaurantAnalytics') ? (isHqUser ? 'hq/analytics' : '/analytics'):null"
        [ngClass]="{
          'link-active': analyticsActive.isActive
        }"
        *ngIf="validUrl['analytics'] && !isKiosk && !isKioskHq"
        (click)="tabclicked('restaurantAnalytics')"
      >
      <div class="flex flex-3 gap-3">
        <div [ngClass]="{'nav-locked-blur': handleBlocked('restaurantAnalytics')}">
          <img [src]="images.ANALYTICS" class="routes-img" alt="analytics"/>
        </div>
        <div class="sidenav-title" [ngClass]="{'nav-locked-blur': handleBlocked('restaurantAnalytics')}">
          <a rel="nofollow">
            <span class="wb-break-word ws-normal">{{ 'SIDENAV.RESTAURANT_ANALYTICS' | fallbackTranslate }}</span>
          </a>
        </div>
      </div>
        <div class="flex flex-center fs-10 locked-bg gap-1"  *ngIf="handleBlocked('restaurantAnalytics')" >
          <img
          [src]="images.RED_LOCK_ICON"
          alt="lock"
        />
          {{ 'SIDENAV.LOCKED' | fallbackTranslate }}
        </div>
      </div>

      <div
        class="sidenav-routes-section-link"
        [routerLink]="isHqUser ? 'hq/staff-center' : '/staff-center'"
        [ngClass]="{
          'link-active': tablesActive.isActive || staffActive.isActive
        }"
        (click)="tabclicked('staff')"
        *ngIf="!isMobile && isHqUser && validUrl['staff_center']"
      >
      <div class="flex flex-3 gap-3">
        <div>
          <img [src]="images.NAV_STAFF" class="routes-img" alt="staff" />
        </div>
        <div class="sidenav-title">
          <a rel="nofollow">
            <span class="wb-break-word ws-normal">
              {{ 'SIDENAV.STAFF_CENTER' | fallbackTranslate }}
            </span>
          </a>
        </div>
      </div>
      </div>
      <div
        class="sidenav-routes-section-link"
        [routerLink]="isHqUser ? 'hq/settlement' : '/settlement'"
        [ngClass]="{
          'link-active': settlementActive.isActive
        }"
        (click)="tabclicked('settlement')"
        *ngIf="
          !isMobile &&
          (showFoodCourtSettlment ||
          isSettlement &&
          ((utilService.litePricingHq(true) && !idCountry) || idCountry) &&
          isHqUser &&
          isAtleastSettlementEnabled &&
          validUrl['settlement'])
        "
      >
      <div class="flex flex-3 gap-3">
        <div>
          <img
            [src]="images.SETTLEMENT"
            class="routes-img"
            alt="settlement"
          />
        </div>
        <div class="sidenav-title">
          <a rel="nofollow">
            <span class="wb-break-word ws-normal">
              {{ 'SIDENAV.SETTLEMENT' | fallbackTranslate }}
            </span>
          </a>
        </div>
      </div>
      </div>
      <div
      class="sidenav-routes-section-link"
      [routerLink]="'hq/e-invoice'"
      [ngClass]="{
        'link-active': eInvoiceActive.isActive
      }"
      (click)="tabclicked('e-invoice')"
      *ngIf="!idCountry && !isKioskHq && isHqUser && validUrl['e-invoice']"
    >
    <div class="flex flex-3 gap-3">
      <div>
        <img [src]="images?.INVOICE_ICON" class="routes-img" alt="invoice-icon" />
      </div>
      <div class="sidenav-title">
        <a rel="nofollow">
          <span class="wb-break-word ws-normal">
            E-Invoice
          </span>
        </a>
      </div>
    </div>
    </div>
      <div
        class="sidenav-routes-section-link flex flex_sb gap-2"
        [routerLink]=" !handleBlocked('sectionsAndCounters') ? '/section-counters' :null"
        [ngClass]="{
          'link-active': sectionsActive.isActive
        }"
        (click)="tabclicked('sectionsAndCounters')"
        *ngIf="validUrl['section-printer'] && !isKioskHq && !isHqUser"
      >
      <div class="flex flex-3 gap-3">
        <div [ngClass]="{'nav-locked-blur': handleBlocked('sectionsAndCounters')}">
          <img
            [src]="images.NAV_SECTION"
            class="routes-img"
            alt="section"
          />
        </div>
        <div class="sidenav-title" [ngClass]="{'nav-locked-blur': handleBlocked('sectionsAndCounters')}">
          <a rel="nofollow">
            <span class="wb-break-word ws-normal">{{ 'SIDENAV.SECTIONS_AND_COUNTERS' | fallbackTranslate }}</span>
          </a>
        </div>
      </div>
        <div class="flex flex-center fs-10 locked-bg gap-1"  *ngIf="handleBlocked('sectionsAndCounters')" >
          <img
          [src]="images.RED_LOCK_ICON"
          alt="lock"
        />
          {{ 'SIDENAV.LOCKED' | fallbackTranslate }}</div>
      </div>
      <div
        class="sidenav-routes-section-link"
        [routerLink]="'hq/loyaltyProgram'"
        [ngClass]="{ 'link-active': loyaltySettingActive.isActive }"
        (click)="tabclicked('loyaltyProgram')"
        *ngIf="isHqUser && !((isKioskHq || isFoodCourt) && isIdEnvironment)"
      >
      <div class="flex flex-3 gap-3">
        <div>
          <img
            [src]="images.NAV_LAYALTY_SETTING"
            class="routes-img"
            alt="loyalty-setting"
          />
        </div>
        <div class="sidenav-title">
          <a rel="nofollow">
            <span class="wb-break-word ws-normal">
              {{ 'SIDENAV.LOYALTY' | fallbackTranslate }}
            </span>
          </a>
        </div>
      </div>
      </div>

      <div
        class="sidenav-routes-section-link"
        [routerLink]="'hq/referralProgram'"
        [ngClass]="{ 'link-active': referralProgramActive.isActive }"
        (click)="tabclicked('referralProgram')"
        *ngIf="isHqUser && showReferralProgram && !hqPricing && !isKioskHq"
      >
        <div>
          <img
            [src]="images.REFERRAL_SIDENAV"
            class="routes-img"
            alt="referral"
          />
        </div>
        <div class="sidenav-title">
          <a rel="nofollow">
            <span class="wb-break-word ws-normal">
              {{ 'SIDENAV.PROGRAM_REFERRAL' | fallbackTranslate }}
            </span>
            </a>
        </div>
      </div>

      <div
        class="sidenav-routes-section-link flex flex_sb gap-2"
        [routerLink]=" !handleBlocked('inventory') ? (isHqUser ? 'hq/inventory' : '/inventory') : null"
        [ngClass]="{ 'link-active': inventoryActive.isActive }"
        *ngIf="!isMobile && validUrl['inventory'] && !isKiosk && !isKioskHq"
        (click)="tabclicked('inventory')"
      >
      <div class="flex flex-3 gap-3">
        <div [ngClass]="{'nav-locked-blur': handleBlocked('inventory')}">
          <img [src]="images.INVENTORY" class="routes-img" alt="inventory" />
        </div>
        <div class="sidenav-title" [ngClass]="{'nav-locked-blur': handleBlocked('inventory')}">
          <a rel="nofollow">
            <span class="wb-break-word ws-normal">{{ 'SIDENAV.INVENTORY' | fallbackTranslate }}</span>
          </a>  
        </div>
      </div>
        <div class="flex flex-center fs-10 locked-bg gap-1"  *ngIf="handleBlocked('inventory')" >
          <img
          [src]="images.RED_LOCK_ICON"
          alt="lock"
        />
          {{ 'SIDENAV.LOCKED' | fallbackTranslate }}</div>
      </div>
      <!-- Discount nav-->
      <div
        class="sidenav-routes-section-link flex flex_sb gap-2"
        [routerLink]=" !handleBlocked('promotions') ?(isHqUser ? 'hq/discounts' : '/discounts') : null"
        [ngClass]="{ 'link-active': discountsActive.isActive }"
        (click)="tabclicked('promotions')"
        *ngIf="validUrl['promotion'] && !isKiosk && showPromotionsOnPos"
      >
      <div class="flex flex-3 gap-3">
        <div [ngClass]="{'nav-locked-blur': handleBlocked('promotions')}">
          <img [src]="images.DISCOUNT_SIDENAV" class="routes-img"  alt="discount"/>
        </div>
        <div class="sidenav-title" [ngClass]="{'nav-locked-blur': handleBlocked('promotions')}">
          <a rel="nofollow">
            <span class="wb-break-word ws-normal">{{ 'SIDENAV.PROMOTIONS' | fallbackTranslate }}</span>
          </a>
        </div>
      </div>
        <div class="flex flex-center fs-10 locked-bg gap-1"  *ngIf="handleBlocked('promotions')" >
          <img
          [src]="images.RED_LOCK_ICON"
          alt="lock"
        />
          {{ 'SIDENAV.LOCKED' | fallbackTranslate }}</div>
      </div>
      <!-- Integration -->
      <div
        class="sidenav-routes-section-link"
        [routerLink]="'hq/integrations'"
        [ngClass]="{ 'link-active': integrationsActive.isActive }"
        (click)="tabclicked('integrations')"
        *ngIf="isHqUser && !isKioskHq"
      >
      <div class="flex flex-3 gap-3">
        <div>
          <img
            [src]="images.INTEGRATION"
            class="routes-img"
            alt="integration-icon"
          />
        </div>
        <div class="sidenav-title">
          <a rel="nofollow">
            <span class="wb-break-word ws-normal">
              Integrations
            </span>
          </a>
        </div>
      </div>
      </div>
      <div
        class="sidenav-routes-section-link"
        *ngIf="isReactDevice"
        (click)="onAppSettingsClick()"
      >
      <div class="flex flex-3 gap-3">
        <div>
          <img [src]="images.COGWHEEL" class="routes-img" alt="cogwheel" />
        </div>
        <div class="sidenav-title">
          <a rel="nofollow">{{ 'SIDENAV.APP_SETTINGS' | fallbackTranslate }}</a>
        </div>
        </div>
      </div>

      <div
        class="sidenav-routes-section-link"
        [routerLink]="isHqUser ? 'hq/help-center' : '/help-center'"
        [ngClass]="{ 'link-active': helpCentreActive.isActive }"
        (click)="tabclicked('helpCentre')"
      >
      <div class="flex flex-3 gap-3">
        <div>
          <img [src]="images.QUESTION" class="routes-img" alt="question-mark" />
        </div>
        <div class="sidenav-title">
          <a rel="nofollow">{{ 'SIDENAV.HELP_CENTER' | fallbackTranslate }}</a>
        </div>
      </div>
      </div>
      <div class="sidenav-routes-section-link" *ngIf="!isUsrLoggedIn()">
        <div>
          <img [src]="images.LOGIN" class="routes-img" alt="login-img" />
        </div>
        <div>
          <button
            style="
              background: green;
              padding: 10px;
              width: 160px;
              border-radius: 5px;
            "
          >
            {{ 'SIDENAV.LOGIN' | fallbackTranslate }}
          </button>
        </div>
      </div>

      <div
        (click)="logout()"
        class="sidenav-routes-section-link flex gap-3"
        *ngIf="isUsrLoggedIn() && (isHqUser || !isLockEnabled)"
      >
        <div>
          <img [src]="images.LOGOUT" class="routes-img" alt="logout-img" />
        </div>
        <div>
          <button class="logout">{{ 'SIDENAV.LOGOUT' | fallbackTranslate }}</button>
        </div>
      </div>

      <div
        class="sidenav-routes-section-link"
        *ngIf="isUsrLoggedIn() && !isHqUser && isLockEnabled"
      >
        <div>
          <img [src]="images.LOGOUT" class="routes-img" alt="logout-img"/>
        </div>
        <div>
          <button (click)="lock_screen()" class="logout">
            {{ 'SIDENAV.LOCK_SCREEN' | fallbackTranslate }}
          </button>
        </div>
      </div>
    </div>

    <!-- template reference for active class of route !!! hidden -->
    <div style="display: none">
      <a
        [routerLink]="['/hq/dashboard']"
        routerLinkActive
        rel="nofollow"
        #eehqActive="routerLinkActive"
      ></a>
      <a
        [routerLink]="['/hq/outlets']"
        routerLinkActive
        rel="nofollow"
        #outletsActive="routerLinkActive"
      ></a>
      <a
        [routerLink]="['/hq/billing']"
        routerLinkActive
        rel="nofollow"
        #billingActive="routerLinkActive"
      ></a>
      <a
        [routerLink]="['/orders']"
        routerLinkActive
        rel="nofollow"
        #ordersActive="routerLinkActive"
      ></a>
      <a
        [routerLink]="['/tables']"
        routerLinkActive
        rel="nofollow"
        #tableLayoutActive="routerLinkActive"
      ></a>
      <a
        [routerLink]="['/table-bookings']"
        routerLinkActive
        rel="nofollow"
        #tablebookingsActive="routerLinkActive"
      ></a>
      <a
      [routerLink]="['/ai-insights']"
      routerLinkActive
      rel="nofollow"
      #aiInsightsTabActive="routerLinkActive"
    ></a>
      <a
        [routerLink]="isHqUser ? ['hq/menu-management'] : ['/menu']"
        routerLinkActive
        rel="nofollow"
        #menuActive="routerLinkActive"
      ></a>
      <a
        [routerLink]="['/dishes']"
        routerLinkActive
        rel="nofollow"
        #dishesActive="routerLinkActive"
      ></a>
      <a
        [routerLink]="isHqUser ? ['hq/staff-center'] : ['/staff-center']"
        routerLinkActive
        rel="nofollow"
        #staffActive="routerLinkActive"
      ></a>
      <a
        [routerLink]="['/tables']"
        routerLinkActive
        rel="nofollow"
        #tablesActive="routerLinkActive"
      ></a>
      <a
        [routerLink]="['/tableservice']"
        routerLinkActive
        rel="nofollow"
        #tableserviceActive="routerLinkActive"
      ></a>
      <a
        [routerLink]="isHqUser ? ['hq/reports'] : ['/reports']"
        routerLinkActive
        rel="nofollow"
        [routerLinkActiveOptions]="{ exact: false }"
        #reportsActive="routerLinkActive"
      ></a>
      <a
        [routerLink]="['/section-counters']"
        routerLinkActive
        rel="nofollow"
        #sectionsActive="routerLinkActive"
      ></a>
      <a
        [routerLink]="['/kitchen']"
        [routerLinkActive]
        rel="nofollow"
        #kitchenActive="routerLinkActive"
      ></a>
      <a
        [routerLink]="['hq/loyaltyProgram']"
        routerLinkActive
        rel="nofollow"
        #loyaltySettingActive="routerLinkActive"
      ></a>
      <a
        [routerLink]="['hq/referralProgram']"
        routerLinkActive
        rel="nofollow"
        #referralProgramActive="routerLinkActive"
      ></a>
      <a
        [routerLink]="['hq/integrations']"
        routerLinkActive
        rel="nofollow"
        #integrationsActive="routerLinkActive"
      ></a>
      <a
        [routerLink]="['hq/marketing']"
        routerLinkActive
        rel="nofollow"
        #marketingSettingActive="routerLinkActive"
      ></a>
      <a
        [routerLink]="isHqUser ? ['hq/analytics'] : ['/analytics']"
        routerLinkActive
        rel="nofollow"
        #analyticsActive="routerLinkActive"
      ></a>
      <a
        [routerLink]="isHqUser ? ['hq/inventory'] : ['/inventory']"
        routerLinkActive
        rel="nofollow"
        #inventoryActive="routerLinkActive"
      ></a>
      <a
        [routerLink]="isHqUser ? ['hq/discounts'] : ['/discounts']"
        routerLinkActive
        rel="nofollow"
        #discountsActive="routerLinkActive"
      ></a>
      <a
        [routerLink]="isHqUser ? ['hq/settlement'] : ['/settlement']"
        routerLinkActive
        rel="nofollow"
        #settlementActive="routerLinkActive"
      ></a>
      <a
        [routerLink]="['hq/e-invoice']"
        routerLinkActive
        rel="nofollow"
        #eInvoiceActive="routerLinkActive"
      ></a>
      <a
        [routerLink]="['hq/pending-orders']"
        routerLinkActive
        rel="nofollow"
        #pendingOrdersActive="routerLinkActive"
      ></a>
      <a
        [routerLink]="isHqUser ? ['hq/help-center'] : ['help-center']"
        routerLinkActive
        rel="nofollow"
        #helpCentreActive="routerLinkActive"
      ></a>
    </div>
    <!-- end template reference -->
  </div>
</div>